import { createContext } from "react";
import { User, UserSession } from "../../models/user";

const sessionUser: User = {
    id: '',
    name: '',
    surname: '',
    email: '',
    username: '',
    password: '',
    company: '',
    taxcode: '',
    vatcode: ''
};
const accessToken = '';
const user: UserSession = {
    jwt: '',
    user: sessionUser,
    authenticated: false,
    isFirstLogin: false
};
const updateAccessToken = (value: string) => {};
const updateUser = (value: UserSession) => {};
const AuthContext = createContext({accessToken, user, updateAccessToken, updateUser});

export default AuthContext;